/** Public configuration. Nothing here is secret. */
interface RuntimeConfig { apiUrl?: string; supabaseUrl?: string; supabaseAnonKey?: string; entraSso?: boolean; push?: boolean }
/**
 * t397u: /runtime-config.js (loaded before the app, see public/runtime-config.js) can override the build-time VITE_*
 * values, so one web image serves several instances. Empty by default, so builds behave exactly as before.
 */
const rc: RuntimeConfig = (typeof globalThis !== 'undefined' && (globalThis as { __HUB_RUNTIME_CONFIG__?: RuntimeConfig }).__HUB_RUNTIME_CONFIG__) || {};
const flag = (v: boolean | undefined, build: unknown) => (typeof v === 'boolean' ? v : build === 'true');

export const env = {
  apiUrl: rc.apiUrl || ((import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000/v1'),
  supabaseUrl: rc.supabaseUrl || (import.meta.env.VITE_SUPABASE_URL as string | undefined) || '',
  supabaseAnonKey: rc.supabaseAnonKey || (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || '',
  entraSso: flag(rc.entraSso, import.meta.env.VITE_ENABLE_ENTRA_SSO),
  devAuth: import.meta.env.VITE_DEV_AUTH === 'true',
  /** Forces the Push column in Settings on. Normally it follows the server (GET me/push/config: Web Push, t232u). */
  push: flag(rc.push, import.meta.env.VITE_ENABLE_PUSH),
};
export const supabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
export const TZ = 'Europe/London';
